import axios from 'axios';
import { PaginationInfo, RequestParams } from 'types/pagination';
import { CollectionFile } from 'types/question';
import { Tag } from 'types/tag';

export const getTags = async (setTags: (val: { id: string; name: string }[]) => void, productCategoryId?: number | null) => {
    try {
        const params = productCategoryId
            ? {
                  'filter[product_category_id]': productCategoryId
              }
            : {};

        const response = await axios.get(`/tag/mains`, { params });

        setTags(response.data.tags);
    } catch (error) {
        console.error(`error in get question tags ${error}`);
    }
};
export const getAtomicTags = async (setTags: (val: { id: string; name: string }[]) => void, productCategoryId?: number | null) => {
    try {
        const params = productCategoryId
            ? {
                  'filter[product_category_id]': productCategoryId
              }
            : {};

        const response = await axios.get(`tag/atomic-tags`, { params });

        setTags(response.data.tags);
    } catch (error) {
        console.error(`error in get question tags ${error}`);
    }
};

export const getTagList = async (setTags: (val: { id: string; name: string }[]) => void, productCategoryId?: number | null) => {
    try {
        const params = productCategoryId
            ? {
                  'filter[product_category_id]': productCategoryId
              }
            : {};

        const response = await axios.get(`/tag/list`, { params });

        setTags(response.data.tags);
    } catch (error) {
        console.error(`error in get question tags ${error}`);
    }
};

export const getLevelTagList = async (setLevelTags: (val: { id: string; name: string }[]) => void, productCategoryId?: number | null) => {
    try {
        const params = productCategoryId
            ? {
                  'filter[product_category_id]': productCategoryId
              }
            : {};

        const response = await axios.get(`/tag/list`, { params });

        setLevelTags(response.data.tags);
    } catch (error) {
        console.error(`error in get question tags ${error}`);
    }
};

export const getTagsBasedOnProductCategory = async (
    setProductTags: (val: { id: string; name: string }[]) => void,
    productCategoryId?: number | null
) => {
    try {
        const params = productCategoryId
            ? {
                  'filter[product_category_id]': productCategoryId
              }
            : {};
        const response = await axios.get(`/tag/mains`, { params });
        const tagData: { id: string; name: string }[] = [];
        const data = response.data.tags;
        data.forEach((e: any) => {
            tagData.push({ id: e.id, name: e.name as string });
        });
        setProductTags(tagData);
    } catch (error) {
        console.error(`error in get question tags ${error}`);
    }
};

export const getProductTags = async (setProductTags: (val: { id: string; name: string }[]) => void) => {
    try {
        const response = await axios.get(`/question/product-tags`);
        const tagData: { id: string; name: string }[] = [];
        for (const [key, value] of Object.entries(response.data.product_tags)) {
            tagData.push({ id: key, name: value as string });
        }
        setProductTags(tagData);
    } catch (error) {
        console.error(`error in get question product tags ${error}`);
    }
};

export const getFullTags = async (
    setTags: (val: Tag[]) => void,
    requestParams: RequestParams,
    setPaginationInfo?: (val: PaginationInfo) => void
) => {
    try {
        const params: any = {
            page: requestParams.page,
            per_page: requestParams.per_page,
            sort: `${requestParams.sort[0].sort === 'desc' ? '-' : ''}${requestParams.sort[0].field}`
        };
        requestParams.filters?.forEach((filter) => {
            params[`filter[${filter.name}]`] = filter.value;
        });
        const response = await axios.get('/tags', { params });

        let availableFilters: any = [];
        response.data.tags.filters.forEach((filter: any) => {
            availableFilters = [...availableFilters, ...filter.items.options];
        });

        setPaginationInfo?.({
            total: response.data.tags.total,
            last_page: response.data.tags.last_page,
            per_page: response.data.tags.per_page,
            sortable_fields: availableFilters.map((a: any) => a.name),
            available_filters: response.data.tags.filters
        });
        setTags(response.data.tags.data);
    } catch (error) {
        console.error(`error in getting tags ${error}`);
    }
};

export const createTag = async (tag: Tag) => {
    const formData = new FormData();

    if (tag.file) {
        const fileData = tag.file as CollectionFile;

        if (fileData?.upload_data) {
            formData.append(
                fileData.file_path
                    .replace(/[^/.]+$/, '')
                    .replace(/\s+/g, '')
                    .replace(/(\.)/g, ''),
                fileData.upload_data
            );
            tag.file.file_path = fileData.file_path
                .replace(/[^/.]+$/, '')
                .replace(/\s+/g, '')
                .replace(/(\.)/g, '');
        }
    }

    for (const [key, value] of Object.entries(tag)) {
        if (value !== null) {
            if (['file'].includes(key)) {
                formData.append(key, JSON.stringify(value));
            } else if (key === 'type') {
                tag.type!.forEach((option) => {
                    formData.append(option.name, option.checked ? '1' : '0');
                });
            } else {
                formData.append(key, value);
            }
        }
    }

    const response = await axios.post('/tags', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return response.status;
};

export const updateTag = async (id: string, tag: Tag) => {
    const formData = new FormData();

    if (tag.file) {
        const fileData = tag.file as CollectionFile;

        if (fileData?.upload_data) {
            formData.append(
                fileData.file_path
                    .replace(/[^/.]+$/, '')
                    .replace(/\s+/g, '')
                    .replace(/(\.)/g, ''),
                fileData.upload_data
            );
            tag.file.file_path = fileData.file_path
                .replace(/[^/.]+$/, '')
                .replace(/\s+/g, '')
                .replace(/(\.)/g, '');
        }
    }

    for (const [key, value] of Object.entries(tag)) {
        if (value !== null) {
            if (['file'].includes(key)) {
                formData.append(key, JSON.stringify(value));
            } else if (key === 'type') {
                tag.type!.forEach((option) => {
                    formData.append(option.name, option.checked ? '1' : '0');
                });
            } else {
                formData.append(key, value);
            }
        }
    }

    formData.append('_method', 'PUT');

    const response = await axios.post(`/tags/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return response.status;
};

export const getParentsTags = async (id: any, setParents: (val: { id: string; name: string }[]) => void) => {
    try {
        const response = await axios.get(`/tag/parents/${id}`);
        const tagData: { id: string; name: string }[] = [];
        for (const [key, value] of Object.entries(response.data.tags)) {
            tagData.push({ id: key, name: value as string });
        }
        setParents(tagData);
    } catch (error) {
        console.error(`error in get parents tags ${error}`);
    }
};

export const getTag = async (id: string, setTag: (val: Tag) => void) => {
    try {
        const response = await axios.get(`/tags/${id}`);
        const tag = response.data.tag;
        tag.parent = response.data.tag.parent || '';
        setTag(response.data.tag);
    } catch (error) {
        console.error(`error in get tag content ${error}`);
    }
};

export const disableTag = async (id: string) => {
    try {
        await axios.delete(`/tags/${id}`);
    } catch (err) {
        console.error(`error in disable tag ${err}`);
    }
};

export const getChildTags = async (
    tags: {
        id: string;
        name: string;
    }[],
    setChilds: (val: { id: string; name: string }[]) => void
) => {
    try {
        const tagData: { id: string; name: string }[] = [];
        tags.forEach(async (element) => {
            const response = await axios.get(`/tags/ancestor/${element.id}`);
            if (response.data && response.data.ancestors) {
                for (const [key, value] of Object.entries(response.data.ancestors)) {
                    tagData.push({ id: key, name: value as string });
                }
            }
        });

        setChilds(tagData);
    } catch (error) {
        console.error(`error in get question tags childs ${error}`);
    }
};

export const getFlagTags = async (id: string, setTags: (val: { id: string; name: string }[]) => void, product_category_id?: number) => {
    try {
        let url = `/tags/flags/${id}`;
        if (product_category_id) {
            url = `/tags/flags/${id}/${product_category_id}`;
        }
        const response = await axios.get(url);
        const tagData: { id: string; name: string }[] = [];
        for (const [key, value] of Object.entries(response.data.flags)) {
            tagData.push({ id: key, name: value as string });
        }
        setTags(tagData);
    } catch (error) {
        console.error(`error in get flags tags ${error}`);
    }
};

/**
 * Retrieve the tag data depending on the tag flag type (ej: 'main', 'library', 'question')
 * @param setTags function to store the tags
 * @param type the type of flag requested to the BE
 */
export const getTagByType = async (
    setTags: (val: { id: string; name: string }[]) => void,
    type: string | null,
    productcategoryid: number
) => {
    const params: any = {
        product_category_id: productcategoryid
    };
    // if (type !== null) {
    //     params[`filter[${type}]`] = true;
    // }
    try {
        const response = await axios.get(`/tag/type`, { params });
        const tagData: { id: string; name: string }[] = [];
        for (const [key, value] of Object.entries(response.data.tags)) {
            tagData.push({ id: key, name: value as string });
        }
        setTags(response.data.tags);
    } catch (error) {
        console.error(`error in get tags ${error}`);
    }
};

export default getTags;
